const menuContent = `
    <div class="mainMenuSection">
        <a id="mainMenuClose" class="mainMenuItem" href="javascript:;">Tancar Menu</a>
    </div>

    <div class="mainMenuSection">
        <a class="mainMenuItem" href="/?region=Garrigues">Les Garrigues</a>
        <a class="mainMenuItemTown" href="/?town=Borges-Blanques">Borges Blanques</a>
        <a class="mainMenuItem" href="/?region=Noguera">La Noguera</a>
        <a class="mainMenuItemTown" href="/?town=Balaguer">Balaguer</a>
        <a class="mainMenuItem" href="/?region=Urgell">L'Urgell</a>
        <a class="mainMenuItemTown" href="/?town=Tàrrega">Tàrrega</a>
        <a class="mainMenuItem" href="/?region=Pla-d_Urgell">El Pla d'Urgell</a>
        <a class="mainMenuItemTown" href="/?town=Mollerussa">Mollerussa</a>
        <a class="mainMenuItem" href="/?region=Segarra">La Segarra</a>
        <a class="mainMenuItemTown" href="/?town=Cervera">Cervera</a>
        <a class="mainMenuItem" href="/?region=Segrià">El Segrià</a>
        <a class="mainMenuItemTown" href="/?town=Lleida">Lleida</a>
        <a class="mainMenuItem" href="/?region=Alt-Urgell">L'Alt Urgell</a>
        <a class="mainMenuItemTown" href="/?town=Cervera">Cervera</a>
        <a class="mainMenuItem" href="/?region=Solsonès">El Solsonès</a>
        <a class="mainMenuItemTown" href="/?town=Solsona">Solsona</a>
        <a class="mainMenuItem" href="/?region=Pallars-Jussà">Pallars Jussà</a>
        <a class="mainMenuItemTown" href="/?town=Tremp">Tremp</a>
        <a class="mainMenuItem" href="/?region=Pallars-Sobirà">Pallars Sobirà</a>
        <a class="mainMenuItemTown" href="/?town=Sort">Sort</a>
        <a class="mainMenuItem" href="/?region=Alta-Ribagorça">Alta Ribagorça</a>
        <a class="mainMenuItemTown" href="/?town=Pont-de-Suert">El Pont de Suert</a>
        <a class="mainMenuItem" href="/?region=Val-d_Aran">Era Val d'Aran</a>
        <a class="mainMenuItemTown" href="/?town=Vielha">Vielha</a>
    </div>    
    <div class="mainMenuSection">
        <a class="mainMenuItem" href="/opening/hello.html">Com publicar?</a>
        <a class="mainMenuItem" href="/opening/imalive.html">I'm alive!</a>
        <a class="mainMenuItem" href="/opening/subscribe.html">Subscriure's</a>
    </div>    
`;


        function menuInsert()
        {
            const menuContainer = document.getElementById('mainMenuNav');
            
            if (menuContainer !== null)
            {
                menuContainer.innerHTML = menuContent;
            }
        }

        export { menuInsert };


